import styles from './accountdetails.module.css';
import ReminderComponent from '../ReminderComponent'
import InteractionComponent from '../InteractionComponent'
import AccountDetailsDetails from './AccountDetailsDetails';
import AccountDetailsSquare from './AccountDetailsSquare';
import { useGetAccountOwner } from '../../api/auth/useGetAccountOwner';
import { useGetLeadDetailsSquare } from '../../api/lead/useGetLeadDetailsSquare';

const AccountDetailContainerWrapper = ({leadID}) => {
  const accountOwner = useGetAccountOwner({leadID: leadID});
  const {leadDetails} = useGetLeadDetailsSquare({leadId: leadID})

  return (
    <div className={styles.wrapper}>
        <AccountDetailsSquare leadDetails={leadDetails} />
        <AccountDetailsDetails accountOwner={accountOwner} leadID={leadID}/>
        <div className='flex justify-between w-full mr-5'>
          <ReminderComponent leadID={leadID} owner={accountOwner}/>
          <InteractionComponent leadID={leadID} owner={accountOwner}/>
        </div>
    </div>
  );
}

export default AccountDetailContainerWrapper;